export default __webpack_public_path__ + "fonts/OpenSans-Semibold-webfont.woff";